export default {
    frontEndStatus: "前置机运行状态",
    appName: "前置机名称",
    versionNo: "版本",
    status: "状态",
    normal: "正常",
    dataModelNum: "各企业创建数模数量",
    userDataCount: "企业用户数据总量",
    legalDataCount: "企业用户存证数量总量",
    dataShopDataCount: "数据商店数据总量",
    dataModelShopDataCount: "数据模型商店数据总量",
    monitor: "CPU/硬盘监控",
    legalCountRank: "存证数量及排行",
    dataShareRank: "数据共享数量及排行",
    hardDisk: "硬盘",
    company: "企业",
    legal: "存证数量",
    rank: "排行",
    callStatistics: {
        all: '全部',
        allAPI: '全部接口',
        lastWeek: '近7天',
        callNumber: 'API 调用次数',
        flowStatistics: 'API 流量统计（kb）',
        startPlaceholder: '开始日期时间',
        endPlaceholder: '结束日期时间',
        successTimes: '成功次数',
        errorTimes: '失败次数',
        totalCalls: '总调用次数',
        totalFlow: '总流量',
        network: '请求失败，',
        refresh: '点击刷新',
        empty: '暂无数据',
        successCount: '成功次数',
        failCount: '失败次数',
        apiSurvival: 'API 存活情况',
        apiName: '接口名称',
        responseContentLength: '响应时长',
        status: '响应编码',
        statusName: '调用结果',
        success: '成功',
        fail: '失败',
    }
}


// WEBPACK FOOTER //
// ./src/views/statistics/statistics.zh-CN.js